import { WeekDays } from '../../types/common/schedulerTypes';

export class SchedulerHelper {
  protected dependencies: any;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getMonthName(monthNumber: number, firstMonthNumber: number = 0): string {
    switch (monthNumber - firstMonthNumber) {
      case 0:
        return this.dependencies.translateFn('January');
      case 1:
        return this.dependencies.translateFn('February');
      case 2:
        return this.dependencies.translateFn('March');
      case 3:
        return this.dependencies.translateFn('April');
      case 4:
        return this.dependencies.translateFn('May');
      case 5:
        return this.dependencies.translateFn('June');
      case 6:
        return this.dependencies.translateFn('July');
      case 7:
        return this.dependencies.translateFn('August');
      case 8:
        return this.dependencies.translateFn('September');
      case 9:
        return this.dependencies.translateFn('October');
      case 10:
        return this.dependencies.translateFn('November');
      case 11:
        return this.dependencies.translateFn('December');
      default:
        return '';
    }
  }

  /**
   * Gets the translated name of the day
   *
   * @param dayNumber
   * @param firstDayNumber
   * @returns
   */
  getDayName(dayNumber: number, firstDayNumber: number = 0): string {
    switch (dayNumber - firstDayNumber) {
      case WeekDays.Monday:
        return this.dependencies.translateFn('Monday');
      case WeekDays.Tuesday:
        return this.dependencies.translateFn('Tuesday');
      case WeekDays.Wednesday:
        return this.dependencies.translateFn('Wednesday');
      case WeekDays.Thursday:
        return this.dependencies.translateFn('Thursday');
      case WeekDays.Friday:
        return this.dependencies.translateFn('Friday');
      case WeekDays.Saturday:
        return this.dependencies.translateFn('Saturday');
      case WeekDays.Sunday:
        return this.dependencies.translateFn('Sunday');
      default:
        return '';
    }
  }

  /**
   * Gets the translated short name of the day
   *
   * @param dayNumber
   * @param firstDayNumber
   * @returns
   */
  getShortDayName(dayNumber: number, firstDayNumber: number = 0): string {
    return this.getDayName(dayNumber, firstDayNumber).substring(0, 3);
  }
}
